import React, { useEffect, useRef } from 'react';
interface ScreenHeadingProps {
  children: React.ReactNode;
  eyebrow?: string;
  focusKey?: string | number;
  size?: 'lg' | 'xl';
}
export function ScreenHeading({
  children,
  eyebrow,
  focusKey,
  size = 'lg'
}: ScreenHeadingProps) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    ref.current?.focus({
      preventScroll: true
    });
  }, [focusKey]);
  return <div data-id="element-549" data-mp="1g6r39q2ib3lb">
      {eyebrow && <p className="mb-2 text-sm font-bold text-teal" data-id="element-550" data-mp="1g4xykgbgetfy">{eyebrow}</p>}
      <h1 ref={ref} tabIndex={-1} className={`screen-heading font-display font-semibold text-forest ${size === 'xl' ? 'text-4xl sm:text-5xl lg:text-6xl' : 'text-3xl sm:text-4xl'}`} data-id="element-551" data-mp="1b6moc4h8ygx7">
        {children}
      </h1>
    </div>;
}